import {
  ButtonGroup,
  Card,
  CardActions,
  CardContent,
  Checkbox,
  FormControlLabel,
  Typography,
} from '@mui/material'
import type { SyntheticEvent } from 'react'
import type { SearchResultItem } from '@/features/search/types'
import { useSearch } from '../../hooks/useSearch'
import { useAppSelector } from '@/redux/hooks'
import { CopyLinkAction } from './actions/CopyLink'
import { DownloadAction } from './actions/DownloadMenu'
import { MediaDetails } from './actions/MediaDetails'
import { CardImage } from './CardImage'

type Props = {
  searchItem: SearchResultItem
}

export const SearchResultCard = (props: Props) => {
  const { searchItem } = props
  const { title, mediaNumber, mediaCode, fileAttachments, id } = searchItem
  const { selectors, updateSelection } = useSearch()

  const currentSelection = useAppSelector(selectors.selectCurrentSelectionRowIds)
  const isChecked = currentSelection.includes(id)

  function handleChange(_event: SyntheticEvent<Element, Event>): void {
    updateSelection(props.searchItem)
  }

  return (
    <Card
      sx={{
        outline: isChecked ? '3px solid #fc0' : undefined,
      }}
      elevation={1}
    >
      <CardContent>
        <FormControlLabel
          label={mediaNumber}
          control={<Checkbox />}
          checked={isChecked}
          onChange={handleChange}
        />
        <Typography
          fontWeight="bold"
          overflow="hidden"
          textOverflow="ellipsis"
          noWrap
          title={title}
        >
          {title}
        </Typography>
        <CardImage {...searchItem} />
      </CardContent>
      <CardActions>
        <ButtonGroup size="small" variant="text" color="info">
          <DownloadAction files={fileAttachments} mediaCode={mediaCode} />
          <CopyLinkAction searchItem={searchItem} />
          <MediaDetails searchItem={searchItem} />
        </ButtonGroup>
      </CardActions>
    </Card>
  )
}
